export function validationsToCreateCheckout(identification) {
  return (
    !Number(identification) ||
    Number(identification) <= 0 ||
    Number(identification) > 999
  );
}

export function validationsToCreateBeneficio(descricao) {
  return (
    !String(descricao) ||
    String(descricao) <= 0 ||
    String(descricao) > 999
  );
}
